import { isEmpty } from 'lodash';
import get from 'lodash/get';
import React from 'react';

import SlimBanner from 'Components/Banner/SlimBanner';

const PreviewSlimBanner = ({ slimBanner }) => {
  if (isEmpty(slimBanner)) return false;


  const images = get(slimBanner, 'images', []);
  const logo = images.find(image => get(image, 'img_type') === 'slim_logo');
  const background = images.find(image => get(image, 'img_type') === 'slim_background');
  const sponsor = images.find(image => get(image, 'img_type') === 'slim_sponsor');

  const logoSrc = get(logo, 'img', '');
  const backgroundSrc = get(background, 'img', '');
  const sponsorSrc = get(sponsor, 'img', '');
  const slimBackgroundColor = get(slimBanner, 'slim_background_colour', '#FFFFFF');
  const slimButtonColor = get(slimBanner, 'slim_button_data.text_colour', '#000000');
  const slimButtonBackgroundColor = get(slimBanner, 'slim_button_data.background_colour', '#FFFFFF');

  return (
    <div className="PreviewSlimBanner container">
      <h1 className="pt-5">Take Over Preview</h1>
      <div className="PreviewSlimBanner__mobilePreviewContainer" style={{ maxWidth: 576 }}>
        <h3>Mobile Banner</h3>
        <div className="PreviewSlimBanner__mobilePreview">
          <SlimBanner
            logoSrc={logoSrc}
            backgroundSrc={backgroundSrc}
            sponsorSrc={sponsorSrc}
            slimButtonColor={slimButtonColor}
            slimButtonBackgroundColor={slimButtonBackgroundColor}
            slimBackgroundColor={slimBackgroundColor}
          />
        </div>
      </div>

      <div className="PreviewSlimBanner__desktopPreviewContainer">
        <h3>Desktop Banner</h3>
        <SlimBanner
          logoSrc={logoSrc}
          backgroundSrc={backgroundSrc}
          sponsorSrc={sponsorSrc}
          slimButtonColor={slimButtonColor}
          slimButtonBackgroundColor={slimButtonBackgroundColor}
          slimBackgroundColor={slimBackgroundColor}
        />

      </div>
    </div>
  );
};


export default PreviewSlimBanner;
